//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'GlasgowComaScalePed',
  data() {
    return {
      defaultJson:{
        "Verbal": "言语反应",
        "To pain": "刺痛睁眼",
        "Withdraws from touch": "触碰后躲避",
        "NoneMOTOR": "无",
        "NoneEYE": "无",
        "Abnormal flexion to pain (short)": "疼痛后异常屈曲",
        "Cries but consolable, inappropriate interactions (short)": "可安慰",
        "Moves spontaneously or purposefully (short)": "自发运动",
        "NoneVERB": "无",
        "Withdraws from pain": "疼痛后躲避",
        "Withdraws from pain (short)": "疼痛后躲避",
        "Inconsolable, agitated": "不可安慰，焦虑不安",
        "Extension to pain (short)": "疼痛后伸展",
        "Abnormal flexion to pain": "疼痛后异常屈曲",
        "To speech": "呼唤睁眼",
        "Extension to pain": "疼痛后伸展",
        "Inconsistently inconsolable, moaning": "不可安慰，低泣",
        "Moves spontaneously or purposefully": "自发的或有目的的运动",
        "Eye Opening": "睁眼反应",
        "E {{ eye }}  V {{ verbal }}  M {{ motor }}": "睁眼 {{ eye }}  言语 {{ verbal }}  运动 {{ motor }}",
        "Verbal Response": "言语反应",
        "Eye": "睁眼反应",
        "GCS %@": "GCS %@",
        "Smiles, orientated to sounds, follows objects, interacts": "笑，对声音有反应，跟随物体，互动",
        "NoneMOTOR (short)": "无",
        "Smiles, orientated to sounds, follows objects, interacts (short)": "笑，互动",
        "Best Motor Response": "运动反应",
        "Motor": "运动反应",
        "Inconsistently inconsolable, moaning (short)": "不可安慰",
        "Cries but consolable, inappropriate interactions": "哭闹但可安慰，不恰当的互动",
        "Spontaneous": "自动睁眼",
        "Withdraws from touch (short)": "触碰后躲避",
        "Inconsolable, agitated (short)": "不可安慰，焦虑不安"
      },
      form:{
        eye:'',
        verbal:'',
        motor:'',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"1",name:'无'},
        {value:"2",name:'刺痛睁眼'},
        {value:"3",name:'呼唤睁眼'},
        {value:"4",name:'自动睁眼'},
      ],
      dataList2:[
        {value:"1",name:'无'},
        {value:"2",name:'不可安慰，焦虑不安',shortName:'不可安慰，焦虑不安'},
        {value:"3",name:'不可安慰，低泣',shortName:'不可安慰'},
        {value:"4",name:'哭闹但可安慰，不恰当的互动',shortName:'可安慰'},
        {value:"5",name:'笑，对声音有反应，跟随物体，互动',shortName:'笑，互动'},  
      ],
      dataList3:[
        {value:"1",name:'无'},
        {value:"2",name:'疼痛后伸展',shortName:'疼痛后伸展'},
        {value:"3",name:'疼痛后异常屈曲',shortName:'疼痛后异常屈曲'},
        {value:"4",name:'疼痛后躲避',shortName:'疼痛后躲避'},
        {value:"5",name:'触碰后躲避',shortName:'触碰后躲避'},
        {value:"6",name:'自发的或有目的的运动',shortName:'自发运动'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // 	eye + verbal + motor
        let result = form.eye + form.verbal + form.motor
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/GlasgowComaScalePed.vue